import React, { useState } from "react";
import Page from "./Page";
import "./CalculatorPage.scss";
import PillorsComp from "../components/PillorsComp";
import CateSubCatSelectionComp from "../components/CateSubCatSelectionComp";
import Loader from "../../components/Loader/Loader";
import CalculatorCard from "../components/card/CalculatorCard";
import { useTranslation } from "react-i18next";
const CalculatorPage = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState([]);
  const { t } = useTranslation();
  return (
    <Page>
      <Loader start={isLoading} />
      <section className="calculator-sec">
        <section className="calculator-head-box">
          <h1 className="title-bannerpwc">{t("calculators")}</h1>
          <p>
            {t(
              "use_these_calculators_to_explore_scenarios_compare_options_and_plan_your_next_financial_move_with_confidence",
            )}
          </p>
        </section>

        <div className="">
          <PillorsComp activeTab={activeTab} setActiveTab={setActiveTab} />
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="all"
              role="tabpanel"
              aria-labelledby="all-tab"
            >
              <CateSubCatSelectionComp
                setSelectedCategory={setSelectedCategory}
                setSelectedSubcategory={setSelectedSubcategory}
                selectedCategory={selectedCategory}
                selectedSubcategory={selectedSubcategory}
                showSubCate={true}
                showCategory={true}
              />

              <div className="card-grid row">
                <CalculatorCard
                  selectedCategory={selectedCategory}
                  selectedSubcategory={selectedSubcategory}
                  activeTab={activeTab}
                  setIsLoading={setIsLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
};

export default CalculatorPage;
